import { serializeSuperjson } from '@lib/superjson';
import {
  CreateSnapQuoteAssignmentRequest,
  CreateSnapQuoteAssignmentRequestParams,
  CreateSnapQuoteAssignmentResponse,
} from '@snap-types/actions/create-snap-quote-assignment';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [createSnapQuoteAssignment, _] = injectMutation<
  {
    params: CreateSnapQuoteAssignmentRequestParams;
    body: CreateSnapQuoteAssignmentRequest;
  },
  CreateSnapQuoteAssignmentResponse
>(
  `${QUOTE_BUILDER_SLICE_NAME}/createSnapQuoteAssignment`,
  ({ params, body }) => ({
    url: buildSnapQuoteUrl(
      params.siteCode,
      params.snapQuoteUuid,
      'assignments',
    ),
    method: 'POST',
    body: serializeSuperjson(body),
  }),
);

export { createSnapQuoteAssignment };
